import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import styles from "./navbar.module.css";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slice/authSlice";
import UserProfile from "../userProfile/UserProfile";
import { lastUpdateDateMobile } from "../../utils/lastUpdateDate";

const Navbar = () => {
  const [showNavbar, setShowNavbar] = React.useState(false);
  const [isMoreOpen, setIsMoreOpen] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const auth = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleClick = () => {
    navigate("/");
  };

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  return (
    <div className={styles.navWrapper}>
      <nav className={styles.navbar}>
        <div className={styles.container}>
          {/* Left section: Menu + Logo */}
          <div className={styles.logoContainer}>
            <div className={styles.menuIcon} onClick={handleShowNavbar}>
              <FontAwesomeIcon
                icon={faBars}
                style={{ width: "18px", height: "18px" }}
              />
            </div>

            <div onClick={handleClick} className={styles.logo}>
              <div className="flex flex-row items-center">
                <h3
                  className="text-3xl font-bold tracking-tight mb-1.5"
                  style={{
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                    fontWeight: 700,
                    letterSpacing: "-0.02em",
                  }}
                >
                  <span style={{ color: "#2C3E50" }}>vikalp</span>
                  {/* <span style={{ color: '#95A5A6' }}>.io</span> */}
                </h3>

                {/* <div
                  className="p-1 ml-2 mt-2 text-[0.65rem] text-blue-800"
                  role="alert"
                >
                  <span className="font-medium text-bold">BETA</span>
                </div> */}
              </div>
            </div>
          </div>

          {/* ✅ Mobile-only Updated Chip */}
          <div className="ml-auto md:mr-10 items-center">
            <span className="px-2 py-[3px] rounded-md bg-orange-100 border border-orange-200 text-[10.5px] font-medium text-orange-800 font-semibold whitespace-nowrap">
              Updated <span className="">{`${lastUpdateDateMobile()}`}</span>
            </span>
          </div>

          {showNavbar ? (
            <div
              className={styles.transparentDiv}
              onClick={() => setShowNavbar(false)}
            ></div>
          ) : null}

          <div
            className={`${styles.navElements} ${showNavbar && styles.active}`}
          >
            <ul onClick={showNavbar && styles.active ? handleShowNavbar : null}>
              <li>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? styles.ActiveNav : null
                  }
                >
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/fixed-deposit-rates"
                  className={({ isActive }) =>
                    isActive ? styles.ActiveNav : null
                  }
                >
                  FD Rates
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/savings-account-interest-rates"
                  className={({ isActive }) =>
                    isActive ? styles.ActiveNav : null
                  }
                >
                  Savings Rates
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/fcnr-deposit-rates"
                  className={({ isActive }) =>
                    isActive ? styles.ActiveNav : null
                  }
                >
                  FCNR Rates
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/credit-cards"
                  className={({ isActive }) =>
                    isActive ? styles.ActiveNav : null
                  }
                >
                  Credit Cards
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/fuel-credit-cards"
                  className={({ isActive }) =>
                    isActive ? styles.ActiveNav : null
                  }
                >
                  Fuel Cards
                </NavLink>
              </li>

              <li className={styles.dropdown}>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsMoreOpen(!isMoreOpen);
                  }}
                  className={`${styles.dropdownToggle} ${
                    (location.pathname === "/rate-tracker" ||
                      location.pathname === "/blog" ||
                      location.pathname === "/feedback")
                      ? styles.dropdownToggleActive
                      : ""
                  }`}
                >
                  More
                  <span className={`${styles.arrow} ${isMoreOpen ? styles.open : ""}`}>
                    ▼
                  </span>
                </div>
                <ul
                  className={`${styles.dropdownMenu} ${
                    isMoreOpen ? styles.open : ""
                  }`}
                >
                  <li>
                    <NavLink
                      to="/rate-tracker"
                      className={({ isActive }) =>
                        isActive ? styles.ActiveNav : null
                      }
                    >
                      Rate Tracker
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/blog"
                      className={({ isActive }) =>
                        isActive ? styles.ActiveNav : null
                      }
                    >
                      Blog
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/feedback"
                      className={({ isActive }) =>
                        isActive ? styles.ActiveNav : null
                      }
                    >
                      Feedback
                    </NavLink>
                  </li>
                </ul>
              </li>

              {/* {auth.isAuthenticated ? (
                <li>
                  <button
                    onClick={handleLogout}
                    type="button"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center inline-flex items-center D:bg-blue-600 D:hover:bg-blue-700 D:focus:ring-blue-800"
                  >
                    Sign out
                  </button>
                </li>
              ) : (
                <div className="flex">
                  <li>
                    <NavLink to={"/signin"}>
                      <button
                        type="button"
                        className="text-gray-900 mr-4 hover:text-white border border-gray-800 hover:bg-gray-900 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center inline-flex items-center D:bg-blue-600 D:hover:bg-blue-700 D:focus:ring-blue-800"
                      >
                        Sign in
                      </button>
                    </NavLink>
                    <NavLink to={"/signup"}>
                      <button
                        type="button"
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center inline-flex items-center D:bg-blue-600 D:hover:bg-blue-700 D:focus:ring-blue-800"
                      >
                        Sign up
                      </button>
                    </NavLink>
                  </li>
                </div>
              )} */}
            </ul>
          </div>

          {/* {auth.isAuthenticated ? <UserProfile /> : null} */}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
